import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "../cn";

const badgeVariants = cva(
  [
    "inline-flex items-center gap-1.5 px-2 py-0.5",
    "text-xs font-medium tracking-wide uppercase",
    "rounded-[var(--radius-sm)] border",
    "text-mono",
  ],
  {
    variants: {
      variant: {
        amber: [
          "border-[var(--color-amber-dim)]",
          "bg-[var(--color-amber-glow)]",
          "text-[var(--color-amber-bright)]",
        ],
        scope: [
          "border-[var(--color-scope-dim)]",
          "bg-[rgb(58_124_165_/_0.10)]",
          "text-[var(--color-scope-bright)]",
        ],
        critical: [
          "border-[var(--color-critical)]/40",
          "bg-[rgb(210_63_35_/_0.08)]",
          "text-[var(--color-critical)]",
        ],
        muted: [
          "border-[var(--color-panel-edge)]",
          "bg-[var(--color-panel-raised)]",
          "text-[var(--color-ink-dim)]",
        ],
      },
    },
    defaultVariants: { variant: "muted" },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant, className }))} {...props} />;
}
